import { DirectUpload } from "@rails/activestorage"

$(function(){
  $('.summernote').summernote({
    height: 500,
    toolbar: [
      ['style', ['style']],
      ['font', ['bold', 'underline', 'clear']],
      ['color', ['color']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['table', ['table']],
      ['insert', ['link', 'picture']],
      ['view', ['fullscreen', 'codeview', 'help']],
    ],
    colorButton: {
      foreColor: '#FF0000',
      backColor: '#FFFFFF',
    },
    callbacks: {
      onImageUpload: function(files) {
        for (var i = 0; i < files.length; i++) {
          uploadImage(this, files[i]);
        }
      }
    }
  });

  $(document).on('cocoon:after-insert', function(e, insertedItem) {
    $(insertedItem).find('.summernote').summernote({
      height: 500,
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['insert', ['link', 'picture']],
        ['view', ['fullscreen', 'codeview', 'help']],
      ],
      colorButton: {
        foreColor: '#FF0000',
        backColor: '#FFFFFF',
      },
      callbacks: {
        onImageUpload: function(files) {
          for (var i = 0; i < files.length; i++) {
            uploadImage(this, files[i]);
          }
        }
      }
    });
  });

  function uploadImage(note, file) {
    const input = $('input#upload-url')[0];
    const url = input.dataset.directUploadUrl
    const upload = new DirectUpload(file, url)
  
    upload.create(function(error, blob) {
      if (error) {
        alert('画像アップロードに失敗しました');
      } else {
        const filepath = '/rails/active_storage/blobs/redirect/' + blob.signed_id + '/' + blob.filename;
        const imgNode = document.createElement('img');
        imgNode.setAttribute('src', filepath);
        imgNode.setAttribute('style', 'max-width: ' + $('.summernote').width() + 'px;');
        $(note).summernote('insertNode', imgNode);
      }
    });
  }
});
